(function () {
//import Alpine from 'alpinejs'
//Alpine.start()
var $80dfc362fc983cdc$var$menuContainer = document.querySelector(".headermenu__container");
var $80dfc362fc983cdc$var$hamburger = document.querySelector(".hamburger");
var $80dfc362fc983cdc$var$menu = document.querySelector(".headermenu__navigation");
var $80dfc362fc983cdc$var$menucontainer = document.querySelector(".headermenu__menu");
var $80dfc362fc983cdc$var$burgerTitle = document.getElementById("burgerTitle");
var $80dfc362fc983cdc$var$burgerClose = document.getElementById("burgerClose");
var $80dfc362fc983cdc$var$burgerOpen = document.getElementById("burgerOpen");
let $80dfc362fc983cdc$var$isActive = false;
if ($80dfc362fc983cdc$var$menuContainer) {
    $80dfc362fc983cdc$var$menuContainer.addEventListener("click", (e)=>{
        e.stopPropagation(); // Prevent the click event from reaching the document click listener
        $80dfc362fc983cdc$var$isActive = !$80dfc362fc983cdc$var$isActive;
        if ($80dfc362fc983cdc$var$isActive) {
            $80dfc362fc983cdc$var$hamburger.classList.add("hamburger-active");
            $80dfc362fc983cdc$var$menu.classList.add("headermenu__navigation--active");
            $80dfc362fc983cdc$var$menucontainer.classList.add("headermenu__menu--active");
            $80dfc362fc983cdc$var$burgerTitle.innerHTML = $80dfc362fc983cdc$var$burgerClose.getAttribute("value");
            $80dfc362fc983cdc$var$menuContainer.ariaExpanded = "true";
        } else {
            $80dfc362fc983cdc$var$hamburger.classList.remove("hamburger-active");
            $80dfc362fc983cdc$var$menu.classList.remove("headermenu__navigation--active");
            $80dfc362fc983cdc$var$menucontainer.classList.remove("headermenu__menu--active");
            $80dfc362fc983cdc$var$burgerTitle.innerHTML = $80dfc362fc983cdc$var$burgerOpen.getAttribute("value");
            $80dfc362fc983cdc$var$menuContainer.ariaExpanded = "false";
            $80dfc362fc983cdc$var$menuContainer.blur();
        }
    });
    document.body.addEventListener("click", (e)=>{
        if ($80dfc362fc983cdc$var$isActive && e.target !== $80dfc362fc983cdc$var$hamburger && !$80dfc362fc983cdc$var$menu.contains(e.target)) {
            // If the menu is open and the click is outside the hamburger and menu, close the menu
            $80dfc362fc983cdc$var$isActive = false;
            $80dfc362fc983cdc$var$hamburger.classList.remove("hamburger-active");
            $80dfc362fc983cdc$var$menu.classList.remove("headermenu__navigation--active");
            $80dfc362fc983cdc$var$menucontainer.classList.remove("headermenu__menu--active");
            $80dfc362fc983cdc$var$menucontainer.ariaExpanded = "false";
            $80dfc362fc983cdc$var$burgerTitle.innerHTML = $80dfc362fc983cdc$var$burgerOpen.getAttribute("value");
            $80dfc362fc983cdc$var$menuContainer.ariaExpanded = "false";
            $80dfc362fc983cdc$var$menucontainer.blur();
        }
    });
}
var $80dfc362fc983cdc$var$searchicon = document.querySelector(".search-icon");
var $80dfc362fc983cdc$var$searchpopupcontainer = document.querySelector(".search-popup-container");
var $80dfc362fc983cdc$var$searchinput = document.querySelector(".search-popup-container-input");
let $80dfc362fc983cdc$var$searchPopupIsOpen = false;
if ($80dfc362fc983cdc$var$searchicon) {
    $80dfc362fc983cdc$var$searchicon.addEventListener("click", (e)=>{
        e.stopPropagation(); // Prevent the click event from reaching the document click listener
        if (e.target !== $80dfc362fc983cdc$var$searchinput) {
            $80dfc362fc983cdc$var$searchPopupIsOpen = !$80dfc362fc983cdc$var$searchPopupIsOpen;
            if ($80dfc362fc983cdc$var$searchPopupIsOpen && e.target !== $80dfc362fc983cdc$var$searchinput) $80dfc362fc983cdc$var$searchpopupcontainer.classList.add("search-popup-container--active");
            else $80dfc362fc983cdc$var$searchpopupcontainer.classList.remove("search-popup-container--active");
        }
    });
    document.body.addEventListener("keydown", (e)=>{
        if (e.keyCode == 27) {
            if ($80dfc362fc983cdc$var$searchPopupIsOpen) {
                $80dfc362fc983cdc$var$searchPopupIsOpen = false;
                $80dfc362fc983cdc$var$searchpopupcontainer.classList.remove("search-popup-container--active");
            }
        }
    });
    document.body.addEventListener("click", (e)=>{
        if ($80dfc362fc983cdc$var$searchPopupIsOpen && e.target !== $80dfc362fc983cdc$var$searchinput) {
            $80dfc362fc983cdc$var$searchPopupIsOpen = false;
            $80dfc362fc983cdc$var$searchpopupcontainer.classList.remove("search-popup-container--active");
        }
    });
}
var $80dfc362fc983cdc$var$continuebutton = document.querySelector(".startpage__continue--animation");
var $80dfc362fc983cdc$var$siteheader = document.querySelector(".site-header");
if ($80dfc362fc983cdc$var$continuebutton) $80dfc362fc983cdc$var$continuebutton.addEventListener("click", (e)=>{
    // Calculate the vertical offset to scroll down 90vh
    const scrollOffset = window.innerHeight * 0.9;
    // Scroll down by setting the new scroll position
    window.scrollTo({
        top: scrollOffset,
        behavior: "smooth" // You can change this to 'auto' for instant scrolling
    });
});
var $80dfc362fc983cdc$var$siteheader = document.getElementById("site-header--startpage");
const $80dfc362fc983cdc$var$logoElement = document.querySelector(".logo-svg");
const $80dfc362fc983cdc$var$loupeElement = document.querySelector(".search-icon");
// Funktion som k�rs n�r anv�ndaren scrollar
if ($80dfc362fc983cdc$var$siteheader) {
    var $80dfc362fc983cdc$var$pathWhite = "/images/andon-white.svg";
    var $80dfc362fc983cdc$var$pathBlack = "/images/andon-black.svg";
    var $80dfc362fc983cdc$var$pathLoupeBlack = "/images/loupe-black.svg";
    var $80dfc362fc983cdc$var$pathLoupeWhite = "/images/loupe-white.svg";
    let hasClass = true;
    function onScroll() {
        const classActive = $80dfc362fc983cdc$var$siteheader.classList.contains("site-header--startpage");
        const imagePath = classActive ? $80dfc362fc983cdc$var$pathWhite : $80dfc362fc983cdc$var$pathBlack;
        const loupePath = classActive ? $80dfc362fc983cdc$var$pathLoupeWhite : $80dfc362fc983cdc$var$pathLoupeBlack;
        // Kontrollera om anv�ndaren har scrollat ner 300px
        if (window.scrollY >= 320) {
            if (hasClass !== classActive) {
                $80dfc362fc983cdc$var$logoElement.src = imagePath;
                $80dfc362fc983cdc$var$loupeElement.src = loupePath;
                hasClass = classActive;
            }
            // Ta bort klassen fr�n siteheader
            $80dfc362fc983cdc$var$siteheader.classList.remove("site-header--startpage");
        } else {
            // L�gg till klassen om anv�ndaren scrollar tillbaka upp till mindre �n 300px
            $80dfc362fc983cdc$var$siteheader.classList.add("site-header--startpage");
            $80dfc362fc983cdc$var$logoElement.src = $80dfc362fc983cdc$var$pathWhite;
            $80dfc362fc983cdc$var$loupeElement.src = $80dfc362fc983cdc$var$pathLoupeWhite;
        }
    }
    // L�gg till en h�ndelselyssnare f�r scrollh�ndelser
    window.addEventListener("scroll", onScroll);
    onScroll();
}

})();
//# sourceMappingURL=main.js.map
